<template>
  <div>
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <v-row style="min-height: 50px">
            <v-col class="mt-5 text-justify" cols="6" sm="6" md="6" lg="6">
              <h1 class="font-weight-bold" style="text-transform: uppercase">
                {{ !getOptMenu ? "Olá" : "" }}
                {{
                  getOptMenu
                    ? getUserNameEntity + " | NIF " + getNIF
                    : getUserName
                }}
              </h1>
              <div>
                <p>
                  Seja Benvivndo ao Console Kyami pay
                </p>
              </div>
            </v-col>

            <v-col class="mt-5 text-right" cols="6" sm="6" md="6" lg="6">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="callMessage"
                      class="mx-auto m-padd-5"
                      color="blue-grey"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-email-outline
                    </v-icon>
                  </template>
                  <span>Correio</span>
                </v-tooltip>
                <!--                <v-tooltip bottom>-->
                <!--                  <template v-slot:activator="{ on, attrs }">-->
                <!--                    <v-icon-->
                <!--                      class="mx-auto m-padd-5"-->
                <!--                      color="blue-grey"-->
                <!--                      dark-->
                <!--                      v-bind="attrs"-->
                <!--                      v-on="on"-->
                <!--                    >-->
                <!--                      mdi-message-outline-->
                <!--                    </v-icon>-->
                <!--                  </template>-->
                <!--                  <span>Chat</span>-->
                <!--                </v-tooltip>-->
                <v-tooltip bottom v-if="getOptMenu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mx-auto m-padd-5"
                      color="blue-grey"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="callCellphone"
                    >
                      mdi-cellphone
                    </v-icon>
                  </template>
                  <span>Telefone</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapHelper } from "@/store/helper";
import { mapHelperEnterprise } from "@/store/helperEnterprise";
import eventBus from "../../main";

export default {
  name: "Great",
  methods: {
    callMessage() {
      eventBus.$emit("openMessageToSendEmail", true);
    },
    callCellphone() {
      eventBus.$emit("openCallCellphone", true);
    }
  },
  computed: {
    ...mapHelper,
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
